<template>
          <div v-if="$route.query.loading !== 'true'">
            <vs-dialog v-if="showWebViewModal == true" class="vs-dialog">
              <div class="flex items-center justify-center vs-dialog-content">
                <div class="text-center p-6 bg-white rounded-lg relative vs-dialog-inner">
                  <button @click="showWebViewModal = false" class="absolute text-gray-500 hover:text-gray-700 p-1 flex items-center justify-center focus:outline-none border-none close-dialog-bottom">
                    <feather-icon icon="XIcon" svgClasses="h-5 w-5 text-[#626262]"/>
                  </button>
                  <img :src="isIOS ? require('@/assets/images/icons/open_app_ios.png') : require('@/assets/images/icons/open_app.png')" class="mx-auto mb-4" :alt="$t('openYourBrowser')"/>
                  <h3 class="mb-2 font-bold text-lg">{{isIOS ? $t('openYourBrowser') : $t('SignInBrowserTitle')}}</h3>
                  <p class="mb-6 text-sm text-gray-600">{{isIOS ? $t('openYourBrowserDesc') : $t('SignInBrowserDesc')}}</p>
                  <vs-button class="w-full" @click="openInBrowser">{{isIOS ? $t('gotIt') : $t('SignInBrowserButton')}}</vs-button>
                </div>
              </div>
            </vs-dialog>
            <login-again v-if="lastUser.type !== '' && !isLogining" :nameDomain="nameDomain"/>
            <div v-if="lastUser.type === ''">
                <div class="text-center mb-20 glot-text-color-EB">
                 <div class="" v-html="$t('LoginTitle')"></div>
                  <b v-for="(name, index) in nameDomain" :key="name">
                    {{name}}
                    <b v-if="index < nameDomain.length - 1">&</b>
                  </b>
                </div>
                <div class="">
                 <div @click="clickLoginOther('Facebook')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                   <img class="inline-block mr-2" src="@/assets/images/icons/facebookIcon.png"/>
                   <a  @keyup.enter.prevent="clickLoginOther('Facebook')" tabindex="0" class="glot-text-color-3B glot-text-font-size-16 font-bold" >{{$t('FacebookSignIn')}}</a>
                   </div>
                 <div @click="clickLoginOther('Google')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                     <img src="@/assets/images/svg/icons/googleIcon.svg" class="mr-2"/>
                   <a tabindex="0" @keyup.enter.prevent="clickLoginOther('Google')" class="glot-text-color-51 glot-text-font-size-16 font-bold">{{$t('GoogleSignIn')}}</a>
                  </div>
                  <div @click="clickLoginOther('Apple')" class="flex rounded-lg glot-background-color-F8 py-3 flex-1 text-center justify-center items-center cursor-pointer mb-4">
                     <img src="@/assets/images/icons/appleIcon.png" class="mr-2"/>
                   <a tabindex="0" @keyup.enter.prevent="clickLoginOther('Apple')" class="glot-text-color-2C glot-text-font-size-16 font-bold">{{$t('AppleSignIn')}}</a>
                  </div>
                </div>
               <form
                @submit.prevent="validForm('loginForm')"
                data-vv-scope="loginForm"
                >
                <div class="mb-2">
                  <vs-divider color="#EBEEFD" class="opacity-50" ><span class="uppercase glot-text-color-EB opacity-50">{{$t('Or')}}</span></vs-divider>
                </div>
                   <vs-input
                    v-validate="'required|glot_login_acc'"
                    data-vv-validate-on="input"
                    name="account"
                    icon-no-border
                    :label-placeholder="$t('YourAccount')"
                    v-model="email"
                    class="w-full"
                    />
                    <div class="text-danger text-sm  mb-6">{{ errors.first('loginForm.account') }}</div>

                    <div class="relative">
                      <vs-input 
                      name="password"
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6'"
                      :type="passwordType"
                      icon-no-border
                      :label-placeholder="$t('YourPassWord')"
                      v-model="password"
                      class="w-full mt-4" 
                        />
                    <span class="absolute m-auto top-0 bottom-0 right-0 mr-4 flex items-center cursor-pointer" >
                    <feather-icon :icon="[passwordIcon]" @click="hidePassword = !hidePassword" svgClasses="h-4 w-4 stroke-current text-grey" class="absolute m-auto top-0 bottom-0 right-0 mr-1" />
                    </span>
                    </div>
                     <div class="text-danger text-sm">{{ errors.first('loginForm.password')  }}</div>
                     <div class="text-danger text-sm">{{ errMessage }}</div>
                    <!-- <div class="glot-text-color-1D mb-10 cursor-pointer">{{$t('ForgotPassword')}}</div> -->
                    <a class="glot-text-color-1D cursor-pointer mb-10 mt-4 inline-block opacity-75" @click="$router.push('/forgotPassword')">{{$t('ForgotPassword')}}</a>
                    <input class="opacity-0 absolute" type="submit"/>
                    <div class="mb-2">
                      <vs-button :disabled="!validateForm" class="w-full glot-background-color-1D" @click="validForm('loginForm')" >{{$t('Login').toUpperCase()}}</vs-button>
                    </div>
                </form>
                
            </div>
        </div>
</template>

<script>

import _throttle from 'lodash/throttle'

import {CONNECT_FACEBOOK, CONNECT_GOOGLE} from '@/config/commonConfig'

import LoginAgain from './LoginAgain'

import {getErrorMessage} from '@/i18n/util'
import {getMainDomain} from '@/utils/getMainDomain'

const { BroadcastChannel } = require('broadcast-channel')

export default {
  components: {
    LoginAgain
  },
  props:{
    nameDomain: String
  },
  data () {
    return {
      email: '',
      password: '',
      hidePassword: true,
      errMessage: '',
      isLogining: false,
      clientId: process.env.VUE_APP_CLIENT_ID,
      scope: process.env.VUE_APP_SCOPE,
      redirectURI: getMainDomain(process.env.VUE_APP_REDIRECT_URL),
      state: process.env.VUE_APP_STATE,
      usePopup: process.env.VUE_APP_USE_POPUP,
      nonce: process.env.VUE_APP_NONE,
      showWebViewModal: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    lastUser () {
      return this.$store.state.LastUser
    },
    passwordType () {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon () {
      return this.hidePassword ? 'EyeIcon' : 'EyeOffIcon'
    },
    isIOS () {
      return /iPad|iPhone|iPod/.test(navigator.userAgent)
    }
  },
  methods:{
    err (msg) {
      if (typeof console !== 'undefined') {
        console.error(`[vue-apple-signin] ${msg}`)
      }
    },
    broadcastOtherTag () {
      const bc = new BroadcastChannel('internal_notification')
      bc.postMessage('New listening connected!')
    },
    clickLogin () {
      this.loginJWT(this)
    },
    clickLoginOther (type) {
      if (type === 'Facebook') {
        window.location.href = CONNECT_FACEBOOK
      }
      if (type === 'Google') {

        const userAgent = navigator.userAgent.toLowerCase()
        const isWebView = /(webview|wv)/i.test(userAgent) ||
              /FBAN|FBAV|Line|Instagram|messenger|zalo/i.test(userAgent) ||
              window.navigator.standalone === true
        if (isWebView) {
          this.showWebViewModal = true
        } else {
          window.location.href = CONNECT_GOOGLE
        }
      }
      if (type === 'Apple') {
        this.$vs.loading({
          background: 'rgba(0, 0, 0, 0.6)'
        })
        window.AppleID.auth.signIn().then((response) => {
          this.$vs.loading.close()
          const {authorization: {id_token}} = response
          this.$router.push(`/auth/apple/callback?access_token=${id_token}`)
        }).catch((err) => {
          this.$vs.loading.close()
          const { message } = err
          if (message) {
            this.$vs.notify({
              title: 'Error',
              text:  message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              fixed: true
            })
          }
        })
      }
    },
    openInBrowser () {
      if (this.isIOS) {
        this.showWebViewModal = false
        return
      }
      window.location.href = `intent:${window.location.href}#Intent;end`
      setTimeout(() => {
        const shareData = {
          url: window.location.href
        }
        navigator.share(shareData)
      }, 2000)
      this.showWebViewModal = false
    },
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()


        return false
      }
      return true
    },
    loginJWT:_throttle(function (vm) {
      vm.errMessage = ''

      // Loading
      vm.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })

      vm.isLogining = true

      const payload = {
        userDetails: {
          email: vm.email,
          password: vm.password
        }
      }

      vm.$store.dispatch('auth/loginJWT', payload)
        .then((res) => { 
          vm.$vs.notify({
            title: 'Login Success',
            text: 'Login Success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          if ((vm.$route.query.continue || vm.$route.query.redirect_uri) && res.data.jwt) {
            const token = res.data.jwt
            // eslint-disable-next-line no-invalid-this
            const editorExtensionId = this.$route.query.extId
            if (token && editorExtensionId) {
              // eslint-disable-next-line no-invalid-this
              this.$store.dispatch('auth/loginExt', {token, extId: editorExtensionId})
            }
            if (!window.opener) {
              const channel = new BroadcastChannel('foobar')
              window.glotId = Date.now()
              channel.postMessage({ focus: window.glotId, forceClose: true }).then(() => {
                channel.close()
              })
            }
            let redirectlink = `${vm.$route.query.continue || vm.$route.query.redirect_uri}?token=${res.data.jwt}`
            Object.keys(vm.$route.query).map(key => {
              if (key !== 'continue') {
                redirectlink += `&${key}=${vm.$route.query[key]}`
              }
            })
            window.location.href = redirectlink
          } else {
            vm.$vs.loading.close() 
            vm.isLogining = false
          }
        })
        .catch(error => {
          vm.$vs.loading.close()
          vm.errMessage = getErrorMessage(error.messages)
          vm.$vs.notify({
            title: 'Error',
            text:  getErrorMessage(error.messages),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            fixed: true
          })
          vm.isLogining = false
        })
    }, 1000),
    validForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.clickLogin(this);
        }
      })
    },
    callOnSuccess () {
    },
    callOnFailure () {
    }
  },
  watch: {
    showWebViewModal (val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },

  beforeDestroy () {
    const self = this
    document.removeEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.removeEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  },
  created () {
    if (this.$route.query.loading) {
      this.$vs.loading({
        background: 'rgba(0, 0, 0, 0.6)'
      })
    }
  },
  mounted () {
    if (this.$route.query.loading) {
      const searchParams = new URLSearchParams(this.$route.query)
      searchParams.delete('loading')
      this.$router.replace(`${this.$route.path}?${searchParams.toString()}`)
      setTimeout(() => {
        this.$vs.loading.close() 
      }, 1000)
    }
    if (!window.opener) {
      const channel = new BroadcastChannel('foobar')
      window.glotId = Date.now()
      channel.postMessage({focus: window.glotId, forceClose: true}).then(() => {
        channel.close()
      })
    }
    if (!window.AppleID) {
      this.err('"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js" needs to be included as a <script>')
      return
    }
    const clientId = this.clientId
    const scope = this.scope
    const redirectURI = this.redirectURI
    const state = this.state
    const nonce = this.nonce
    const usePopup = this.usePopup === 'true'

    if (!clientId) {
      this.err('options.clientId must be specified.')
      return
    }

    if (!redirectURI) {
      this.err('options.redirectURI must be specified.')
      return
    }

    if (!state) {
      this.err('options.state must be specified.')
      return
    }
    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
      state,
      usePopup,
      nonce
    })
    const self = this
    document.addEventListener('AppleIDSignInOnSuccess', self.callOnSuccess)
    document.addEventListener('AppleIDSignInOnFailure', self.callOnFailure)
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.vs-dialog {
  background-color: transparent !important;
  position: fixed !important;
  z-index: 9999 !important;
}
.close-dialog-bottom{
  top: -5px;
  right: -5px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.vs-dialog-inner{
  max-width: 90%;
}
.vs-dialog-content{
  background: rgba(0, 0, 0, 0.4) !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0;
  right: 0;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9998 !important;
  overflow: hidden !important;
}
</style>
